// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.plansMain {
  background-color: #07405E;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  overflow-y: auto;
}
.plansMain .plansContainer {
  height: 85%;
  width: 97%;
  height: 100dvh;
  padding: 10px;
  /* Dots */
  /* Custom Slick Dots */
}
@media (min-width: 450px) {
  .plansMain .plansContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .plansMain .plansContainer {
    height: 100%;
  }
}
.plansMain .plansContainer .plansSlider {
  margin-top: 10dvh;
}
.plansMain .plansContainer .plansSlider .planElement {
  display: flex;
  width: 80%;
  padding: 24px 16px 24px 24px;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  gap: 10px;
  margin-top: 12px;
  position: relative;
  background-color: #124D6f;
  border-radius: 10px;
}
.plansMain .plansContainer .plansSlider .planElement .planButton {
  width: 31px;
  height: 31px;
  border-radius: 15px;
  background-color: #216B93;
  border: 2px solid #699BB6;
}
.plansMain .plansContainer .plansSlider .planElement .selectedPlan {
  background-color: #FFFFFF;
  border: 7px solid #FF6B6B;
  position: relative;
}
.plansMain .plansContainer .plansSlider .planElement .selectedPlan::after {
  content: "";
  height: 36px;
  width: 35px;
  border-radius: 20px;
  top: -9.5px;
  left: -9px;
  z-index: -1;
  position: absolute;
  background-color: #FFFFFF;
}
.plansMain .plansContainer .plansSlider .planElement .planInfo {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
  min-height: 350px;
}
.plansMain .plansContainer .plansSlider .planElement .planInfo .planIcon {
  margin: 0 auto;
}
.plansMain .plansContainer .plansSlider .planElement .planInfo .planTitle {
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  margin-top: 30px;
  margin-bottom: 10px;
}
.plansMain .plansContainer .plansSlider .planElement .planInfo p {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding: 0px;
  margin: 0px;
}
.plansMain .plansContainer .plansSlider .planElement .buyNowButton {
  padding: 10px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  width: 90%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  border: 0px solid;
  margin: 0 auto;
  margin-top: 60px;
}
.plansMain .plansContainer .plansSlider .selectedPlanElement::before {
  content: "";
  position: absolute;
  border-radius: 10px;
  inset: 0;
  padding: 12px;
  border: 3px solid transparent;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B) border-box;
  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
}
.plansMain .plansContainer .plansSlider .activePlanElement {
  background: linear-gradient(to right, #6D4ECB, #FF6B6B) border-box;
}
.plansMain .plansContainer .plansSlider .activePlanElement p {
  color: #FFFFFF !important;
  opacity: 0.6;
}
.plansMain .plansContainer .plansSlider .activePlanElement .buyNowButton {
  background: transparent;
  cursor: default;
}
.plansMain .plansContainer .slick-slider {
  margin-bottom: 8px;
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}
.plansMain .plansContainer .slick-list {
  position: relative;
  display: block;
  /* overflow: hidden; */
  margin: 0;
  padding: 0;
}
.plansMain .plansContainer .slick-list:focus {
  outline: none;
}
.plansMain .plansContainer .slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}
.plansMain .plansContainer .slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}
.plansMain .plansContainer [dir=rtl] .slick-slide {
  float: right;
}
.plansMain .plansContainer .slick-slide img {
  display: block;
}
.plansMain .plansContainer .slick-slide.slick-loading img {
  display: none;
}
.plansMain .plansContainer .slick-slide.dragging img {
  pointer-events: none;
}
.plansMain .plansContainer .slick-initialized .slick-slide {
  display: block;
}
.plansMain .plansContainer .slick-loading .slick-slide {
  visibility: hidden;
}
.plansMain .plansContainer .slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}
.plansMain .plansContainer .slick-arrow.slick-hidden {
  display: none;
}
.plansMain .plansContainer .slick-dotted.slick-slider {
  margin-bottom: 30px;
}
.plansMain .plansContainer .slick-dots li {
  position: relative;
  display: inline-block;
  width: 10px;
  height: 4px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
  transition: width 0.3s ease-in-out;
}
.plansMain .plansContainer .slick-dots li button:hover,
.plansMain .plansContainer .slick-dots li button:focus {
  outline: none;
}
.plansMain .plansContainer .slick-dots li button:hover:before,
.plansMain .plansContainer .slick-dots li button:focus:before {
  opacity: 1;
}
.plansMain .plansContainer .slick-dots li button:before {
  font-family: "slick";
  font-size: 6px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  content: "•";
  text-align: center;
  opacity: 0.25;
  color: black;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.plansMain .plansContainer .slick-dots li.slick-active button:before {
  opacity: 0.75;
  color: black;
}
@keyframes loading {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
.plansMain .plansContainer .ft-slick__dots--custom {
  height: 4px;
  width: 40px;
  background-color: #e5e7e9;
  opacity: 0.2;
  border-radius: 4px;
  position: relative;
}
.plansMain .plansContainer .slick-dots li {
  width: 40px;
  margin: 0 5px;
  transition: width 0.3s ease-in-out;
}
.plansMain .plansContainer .slick-dots .slick-active {
  width: 40px;
  transition: width 0.3s ease-in-out;
}
.plansMain .plansContainer .slick-dots .slick-active .ft-slick__dots--custom {
  opacity: 0.6;
  width: 40px;
  top: 0px;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/modules/plans/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AACI;EAII,WAAA;EAKA,UAAA;EACA,cAAA;EACA,aAAA;EAgME,SAAA;EAmDA,sBAAA;AAvPV;AANQ;EADJ;IAEQ,YAAA;EASV;AACF;AAPQ;EALJ;IAMQ,YAAA;EAUV;AACF;AALQ;EACI,iBAAA;AAOZ;AALY;EACI,aAAA;EACA,UAAA;EACA,4BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAOhB;AALgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBClCA;EDmCA,yBAAA;AAOpB;AAJgB;EACI,yBChDP;EDiDO,yBAAA;EACA,kBAAA;AAMpB;AAJgB;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAMpB;AAJgB;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAMpB;AALoB;EACI,cAAA;AAOxB;AALoB;EACI,cCzEX;ED0EW,iCErEf;EFsEe,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAOxB;AALqB;EACG,cClFP;EDmFO,iCE/Ef;EFgFe,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAOxB;AAJgB;EACI,aAAA;EACA,uDAAA;EACA,kBAAA;EACA,cCjGP;EDkGO,iCE7FX;EF8FW,gBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAMpB;AAHY;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,6BAAA;EACA,kEAAA;EACA,8EAAA;EAEA,uBAAA;AAKhB;AAHY;EACI,kEAAA;AAKhB;AAJgB;EACI,yBAAA;EACA,YAAA;AAMpB;AAJgB;EACI,uBAAA;EACA,eAAA;AAMpB;AAFQ;EACI,kBAAA;EAEA,kBAAA;EAEA,cAAA;EACA,sBAAA;EAEA,yBAAA;EAGA,iBAAA;EAEA,2BAAA;EACA,wBAAA;EAEA,mBAAA;EACA,wCAAA;AAAZ;AAGU;EACE,kBAAA;EAEA,cAAA;EACA,sBAAA;EAEA,SAAA;EACA,UAAA;AAHZ;AAKU;EACE,aAAA;AAHZ;AAKU;EACE,eAAA;EACA,YAAA;AAHZ;AAOU;EACE,aAAA;EACA,WAAA;EAEA,YAAA;EACA,eAAA;AANZ;AAQU;EACE,YAAA;AANZ;AAQU;EACE,cAAA;AANZ;AAQU;EACE,aAAA;AANZ;AAQU;EACE,oBAAA;AANZ;AAQU;EACE,cAAA;AANZ;AAQU;EACE,kBAAA;AANZ;AAQU;EACE,cAAA;EAEA,YAAA;EAEA,6BAAA;AARZ;AAUU;EACE,aAAA;AARZ;AAcU;EACE,mBAAA;AAZZ;AAgBU;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,kCAAA;AAdZ;AAiBU;;EAEE,aAAA;AAfZ;AAiBU;;EAEE,UAAA;AAfZ;AAiBU;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;EAEA,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,WAAA;EACA,YAAA;EAEA,YAAA;EACA,kBAAA;EAEA,aAAA;EACA,YAAA;EAEA,mCAAA;EACA,kCAAA;AApBZ;AAsBU;EACE,aAAA;EACA,YAAA;AApBZ;AAyBU;EACE;IACE,SAAA;EAvBZ;EA0BU;IACE,WAAA;EAxBZ;AACF;AA2BU;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAzBZ;AA4BU;EACE,WAAA;EACA,aAAA;EACA,kCAAA;AA1BZ;AA6BU;EACE,WAAA;EACA,kCAAA;AA3BZ;AA8BU;EACE,YAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;AA5BZ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.plansMain {\n    background-color: #07405E;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    overflow-y: auto;\n    .plansContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        height: 85%;\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n\n        width: 97%;\n        height: 100dvh;\n        padding: 10px;\n        .plansSlider{\n            margin-top: 10dvh;\n   \n            .planElement{\n                display: flex;\n                width: 80%;\n                padding: 24px 16px 24px 24px;\n                align-items:center;\n                justify-content: center;\n                margin: 0 auto;\n                gap: 10px;\n                margin-top: 12px;\n                position: relative;\n                background-color: #124D6f;\n                border-radius: 10px;\n                \n                .planButton{\n                    width: 31px;\n                    height: 31px;\n                    border-radius: 15px;\n                    background-color: $color-Gradient-1-1;\n                    border: 2px solid $color-Secondary;\n                    \n                }\n                .selectedPlan{\n                    background-color: $color-White;\n                    border: 7px solid $color-Gradient-2-2;\n                    position: relative;\n                }\n                .selectedPlan::after{\n                    content: \"\";\n                    height: 36px;\n                    width: 35px;\n                    border-radius: 20px;\n                    top: -9.5px;\n                    left: -9px;\n                    z-index: -1;\n                    position: absolute;\n                    background-color: #FFFFFF;\n                }\n                .planInfo{\n                    display: flex;\n                    flex-direction: column;\n                    width: 100%;\n                    text-align: center; \n                    min-height: 350px;\n                    .planIcon{\n                        margin: 0 auto;\n                    }\n                    .planTitle{\n                        color: $color-White;\n                        font-family: $Roboto;\n                        font-size: 20px;\n                        font-style: normal;\n                        font-weight: 500;\n                        line-height: 140%;\n                        margin-top: 30px;\n                        margin-bottom: 10px;\n                    }\n                     p{\n                        color: $color-Secondary;\n                        font-family: $Roboto;\n                        font-size: 17px;\n                        font-style: normal;\n                        font-weight: 400;\n                        line-height: 150%;\n                        padding: 0px;\n                        margin: 0px;\n                    }\n                }\n                .buyNowButton{\n                    padding: 10px;\n                    background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n                    text-align: center;\n                    color: $color-White;\n                    font-family: $Roboto;\n                    font-weight: 400;\n                    width: 90%;\n                    cursor: pointer;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    border-radius: 10px;\n                    text-align: center;\n                    font-size: 16px;\n                    font-style: normal;\n                    border:0px solid;\n                    margin: 0 auto;\n                    margin-top: 60px;\n                }\n            }\n            .selectedPlanElement::before{\n                content: \"\";\n                position: absolute;\n                border-radius: 10px; \n                inset: 0;\n                padding: 12px; \n                border: 3px solid transparent; \n                background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2) border-box;\n                -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);\n                -webkit-mask-composite: xor; \n                mask-composite: exclude;\n            }\n            .activePlanElement{\n                background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2) border-box;\n                p{\n                    color: $color-White !important;\n                    opacity: 0.6;\n                }\n                .buyNowButton{\n                    background:transparent;\n                    cursor: default;\n                }\n            }\n        }\n        .slick-slider {\n            margin-bottom: 8px;\n        \n            position: relative;\n        \n            display: block;\n            box-sizing: border-box;\n        \n            -webkit-user-select: none;\n            -moz-user-select: none;\n            -ms-user-select: none;\n            user-select: none;\n        \n            -webkit-touch-callout: none;\n            -khtml-user-select: none;\n            -ms-touch-action: pan-y;\n            touch-action: pan-y;\n            -webkit-tap-highlight-color: transparent;\n          }\n        \n          .slick-list {\n            position: relative;\n        \n            display: block;\n            /* overflow: hidden; */\n        \n            margin: 0;\n            padding: 0;\n          }\n          .slick-list:focus {\n            outline: none;\n          }\n          .slick-list.dragging {\n            cursor: pointer;\n            cursor: hand;\n          }\n        \n        \n          .slick-slide {\n            display: none;\n            float: left;\n        \n            height: 100%;\n            min-height: 1px;\n          }\n          [dir=\"rtl\"] .slick-slide {\n            float: right;\n          }\n          .slick-slide img {\n            display: block;\n          }\n          .slick-slide.slick-loading img {\n            display: none;\n          }\n          .slick-slide.dragging img {\n            pointer-events: none;\n          }\n          .slick-initialized .slick-slide {\n            display: block;\n          }\n          .slick-loading .slick-slide {\n            visibility: hidden;\n          }\n          .slick-vertical .slick-slide {\n            display: block;\n        \n            height: auto;\n        \n            border: 1px solid transparent;\n          }\n          .slick-arrow.slick-hidden {\n            display: none;\n          }\n        \n\n        \n          /* Dots */\n          .slick-dotted.slick-slider {\n            margin-bottom: 30px;\n          }\n        \n         \n          .slick-dots li {\n            position: relative;\n            display: inline-block;\n            width: 10px;\n            height: 4px;\n            margin: 0 5px;\n            padding: 0;\n            cursor: pointer;\n            transition: width 0.3s ease-in-out;\n          }\n         \n          .slick-dots li button:hover,\n          .slick-dots li button:focus {\n            outline: none;\n          }\n          .slick-dots li button:hover:before,\n          .slick-dots li button:focus:before {\n            opacity: 1;\n          }\n          .slick-dots li button:before {\n            font-family: \"slick\";\n            font-size: 6px;\n            line-height: 20px;\n        \n            position: absolute;\n            top: 0;\n            left: 0;\n        \n            width: 10px;\n            height: 10px;\n        \n            content: \"•\";\n            text-align: center;\n        \n            opacity: 0.25;\n            color: black;\n        \n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n          }\n          .slick-dots li.slick-active button:before {\n            opacity: 0.75;\n            color: black;\n          }\n        \n          /* Custom Slick Dots */\n        \n          @keyframes loading {\n            from {\n              width: 0%;\n            }\n        \n            to {\n              width: 100%;\n            }\n          }\n        \n          .ft-slick__dots--custom {\n            height: 4px;\n            width: 40px;\n            background-color: #e5e7e9;\n            opacity: 0.2;\n            border-radius: 4px;\n            position: relative;\n          }\n        \n          .slick-dots li {\n            width: 40px;\n            margin: 0 5px;\n            transition: width 0.3s ease-in-out;\n          }\n        \n          .slick-dots .slick-active {\n            width: 40px;\n            transition: width 0.3s ease-in-out;\n          }\n        \n          .slick-dots .slick-active .ft-slick__dots--custom {\n            opacity: 0.6;\n            width: 40px;\n            top: 0px;\n            overflow: hidden;\n        \n           \n          }\n    }\n}","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
